import { getVisitorId } from "./utils";

const REQUEST_ID_HEADER = "X-Cloud-Trace-Context";
const REFERRER_HEADER = "x-cloud-referrer";
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN || "";
const API_TOKEN =
  "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJST0xFIjoiQVBJIiwic3ViIjoiS2FyYW4gR291ciBUZXN0IiwiT1JHX0lEIjoiNDciLCJpc3MiOiJhZGl0eWFAYmljeWNsZS5haSIsImlhdCI6MTc0NjcwMTYwOCwiVEVOQU5UIjoiZXZ0LWE1NjFiZmJmLTUzYWYtNDM2Ny04NTI3LTQ4MGRmMzQzMDkxMSIsImp0aSI6ImVkYzc0YjI0LTk4M2ItNDYxMS04Y2UifQ.PMCCm5dtxh0JaMTEa4JKv3uwCz-AT9cZkuKjQ054o5Y";

type AppConfig = {
  sentryDsn: string;
  visitorId: string;

  // Axios configuration
  requestIdHeader: string;
  referrerHeader: string;
  apiToken: string;

  // Company microsite
  isCompanyCreated: boolean;
  companyName: string;
  pollId: string;
  enableDemo: boolean;
  isLocalDevServer: boolean;
  enableV3: boolean;
};

const appConfig: AppConfig = {
  requestIdHeader: REQUEST_ID_HEADER,
  referrerHeader: REFERRER_HEADER,
  apiToken: API_TOKEN,
  sentryDsn: SENTRY_DSN,
  isCompanyCreated: false,
  companyName: "",
  pollId: "",
  visitorId: getVisitorId(),
  enableDemo: false,
  isLocalDevServer: false,
  enableV3: false
};

export default appConfig;
